import './styles.scss'

if (document.querySelector('.youtube')) {
    const setVideo = (n) => {
        const navEl = document.querySelector('.youtube__navigation'),
        count = parseInt(navEl.getAttribute('data-count'))

        if (n > count - 1) {
            n = 0
        } else if (n < 0) {
            n = count - 1
        }

        navEl.setAttribute('data-current', n)

        const video = getVideo(n),
        nextVideo = getVideo(((n + 1) === (count)) ? 0 : n + 1),
        num = n + 1

        document.querySelector('.youtube__pagination-current').textContent = (num < 10 ? '0' : '') + num
        
        document.querySelector('.youtube__current-slide').style.backgroundImage = `url(${ video.PREVIEW })`
        document.querySelector('.youtube__current-slide').classList.remove('youtube__current-slide_active')
        document.querySelector('.youtube__current-slide-code').innerHTML = ''
        document.querySelector('.youtube__slide-title').textContent = video.TITLE
        document.querySelector('.youtube__slide-date').textContent = video.DATE

        document.querySelector('.youtube__next-slide').style.backgroundImage = `url(${ nextVideo.PREVIEW })`
        document.querySelector('.youtube__next-slide-title').textContent = nextVideo.TITLE
        document.querySelector('.youtube__next-slide-date').textContent = nextVideo.DATE
    },
    getVideo = (num) => {
        const n = (num >= 0) ? num : parseInt(document.querySelector('.youtube__navigation').getAttribute('data-current')),
        parent = document.querySelector(`.youtube__video[data-id="${ n }"]`)
        
        const video = {
            ID : parent.querySelector('.youtube__video-id').textContent.trim(),
            TITLE : parent.querySelector('.youtube__video-title').textContent.trim(),
            LINK : parent.querySelector('.youtube__video-link').textContent.trim(),
            PREVIEW : parent.querySelector('.youtube__video-preview').textContent.trim(),
            DATE : parent.querySelector('.youtube__video-date').textContent.trim(),
        }

        return video
    }

    document.querySelector('.youtube__arrow_prev').addEventListener('click', () => {
        const n = parseInt(document.querySelector('.youtube__navigation').getAttribute('data-current'))
        setVideo(n - 1)
    })

    document.querySelector('.youtube__arrow_next').addEventListener('click', () => {
        const n = parseInt(document.querySelector('.youtube__navigation').getAttribute('data-current'))
        setVideo(n + 1)
    })

    document.querySelector('.youtube__next-slide').addEventListener('click', () => {
        const n = parseInt(document.querySelector('.youtube__navigation').getAttribute('data-current'))
        setVideo(n + 1)
    })

    document.querySelector('.youtube__current-slide').addEventListener('click', (e) => {
        const video = getVideo(),
        code = `<iframe width="560" height="315" src="${ video.LINK }?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`

        document.querySelector('.youtube__current-slide-code').innerHTML = code

        e.target.classList.add('youtube__current-slide_active')
    })
}